// Turns the backend's structured 402 detail ({error, plan, cap, access_state})
// into a friendly, human-readable message. Falls back to the raw string detail.

import { ONPREM } from './edition';

function capitalize(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

export function isBillingError(detail) {
  return !!(detail && typeof detail === 'object' &&
    (detail.error === 'cap_reached' || detail.error === 'write_blocked'));
}

export function describeBillingError(detail, fallback) {
  if (detail && typeof detail === 'object') {
    if (detail.error === 'cap_reached' && ONPREM) {
      return `You've reached your ${capitalize(detail.plan)} plan limit of ${detail.cap} ` +
        `dealers + observers. A product key for a larger plan is needed to add more (see License).`;
    }
    if (detail.error === 'write_blocked' && detail.message) {
      return detail.message;
    }
    if (detail.error === 'cap_reached') {
      return `You've reached your ${capitalize(detail.plan)} plan limit of ${detail.cap} ` +
        `dealers + observers. Upgrade your plan to add more.`;
    }
    if (detail.error === 'write_blocked') {
      if (detail.access_state === 'read_only') {
        return 'Your subscription has lapsed, so the account is in read-only mode. ' +
          'Update your payment to restore full access.';
      }
      if (detail.access_state === 'locked') {
        return 'This account is locked after an extended lapse. Update your payment to reactivate.';
      }
      return 'Changes are currently paused for this account. See Billing for details.';
    }
    return fallback;
  }
  return detail || fallback;
}
